import axios from '../request/http';
const Login = {
    
    // 获取手机验证码
    getPhoneCode(params) {
        return axios.get("/api/login/send/phone_code", { params });
    },
       // 获取微信授权签名参数
       getweixin(params) {
        return axios.get("/service-app/index/app/open", { params });
    },
    // 手机登录
    getphoneLogin(data) {
        return axios.post("/api/login/app_phone", data);
    },
    // 获取个人信息
    getuserinfo(params) {
        return axios.get("/api/user/info", { params });
    },
    // 获取商品详情
    getGoodsInfo(params){
        return axios.get("/hemei-order/agricultural/goodsInfo", { params });
    },
    // 获取商品评价
	getGoodsEvaluate(params){
		return axios.get("/hemei-order/agricultural/getGoodsEvaluate", { params });
	},
    // 文章详情
	detailportal(params) {
		return axios.get("/service-article/portal/article/detail", { params });
	},

    //用户评论数查询
	commentCounts(params) {
        return axios.get("/service-article/comment/counts", { params });
	},
	//评论列表
	commentList(params) {
        return axios.get("/service-article/comment/list", { params });
	},
    //获取乡村详情
	getVillageDetail(params) {
        return axios.get("/service-app/village/detail", { params });
	},
    //获取乡村文化
	getRuralCulture(params) {
        return axios.get("/service-app/culture/culture/list", { params });
	},
    // 查询周边信息
	getAreaInfo(params){
        return axios.get("/service-app/village/arround/list", { params });
	},
        // 查询版本最新信息
        getNewestAppVersionInfo(params){
        return axios.post("/hemei-admin/appVersion/getNewestAppVersionInfo",null, { params });
	},
    // 查询文章详情
	articleDetail(params){
        return axios.get("/service-article/portal/article/articleDetail", { params });
	},
    //获取资讯评论树形结构 
    CommentTree(params){
        return axios.get("/service-article/comment/new/getArticle/CommentTree", { params });
    },
    // 获取评价列表
    getCommentList(params) {
        return axios.get("/service-article/comment/new/getList", { params });
    },
    // 获取党组织信息
    getPartyList(params) {
        return axios.get("/service-app/party/party/memberDetail", { params });
    },
    // 获取文章列表
    getArticleList(params) {
        return axios.get("/service-article/portal/article/getList", { params });
    },
    // 获取乡村关注数
    getFollowVillageCount(params) {
        return axios.get("/service-user/follower/followVillageCount", { params });
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js